import { useKeycloak } from "@react-keycloak/web";
import { useRole } from "../services/RoleProvider";
import { useCallback } from "react";

export const useRoleCheck = () => {
  const { keycloak } = useKeycloak();
  const { handleUnauthorized } = useRole();

  const checkRole = useCallback(() => {
    if (!keycloak.authenticated) return true;
    
    const roles = keycloak.tokenParsed?.realm_access?.roles || [];
    if (!roles.includes("REVIEW_TRIPS")) {
      handleUnauthorized();
      return false;
    }
    return true;
  }, [keycloak.authenticated, keycloak.tokenParsed?.realm_access?.roles, handleUnauthorized]);

  return { checkRole };
}; 